import { render, staticRenderFns } from "./DashboardDiscover.vue?vue&type=template&id=14b66aa8&scoped=true&"
import script from "./DashboardDiscover.vue?vue&type=script&lang=js&"
export * from "./DashboardDiscover.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDiscover.vue?vue&type=style&index=0&id=14b66aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b66aa8",
  null
  
)

export default component.exports